import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageViewService {
  // Sticky button observables
  public stickyButtonContent$ = new BehaviorSubject<TemplateRef<any> | null>(
    null
  );

  // Add any additional helper methods if needed
  public setStickyButton(
    content: TemplateRef<any>,
    callback: Function = () => {}
  ) {
    this.stickyButtonContent$.next(content);
  }

  public clearStickButton() {
    this.stickyButtonContent$.next(null);
  }

  /**
   * Sets the content and callback for the sticky button
   * @param content - TemplateRef containing the button content
   * @param callback - Function to be called when the button is clicked
   */
  setButtonContent(content: TemplateRef<any>, callback: Function = () => {}) {
    this.stickyButtonContent$.next(content);
  }

  /**
   * Clears the content and callback when not needed
   */
  clearButtonContent() {
    this.stickyButtonContent$.next(null);
  }
}
